/**
 * Lightweight bridge so the global Header can know Credentials Vault unlock
 * status without mounting VaultCryptoProvider above the whole app shell.
 */

let state = {
  active: false,
  side: null, // 'corporate' | 'personal' | null
  corporateUnlocked: false,
  personalUnlocked: false,
};

const listeners = new Set();

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(state);
    } catch (_) {
      /* ignore subscriber errors */
    }
  });
}

export function getCredentialVaultNavAddState() {
  return state;
}

/**
 * @param {Partial<typeof state>} partial
 */
export function setCredentialVaultNavAddState(partial) {
  state = { ...state, ...partial };
  emit();
}

export function clearCredentialVaultNavAddState() {
  state = {
    active: false,
    side: null,
    corporateUnlocked: false,
    personalUnlocked: false,
  };
  emit();
}

export function subscribeCredentialVaultNavAddState(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Whether the navbar/list Add credential control should be shown. */
export function canShowCredentialVaultNavAdd(snapshot = state) {
  if (!snapshot.active) return false;
  if (snapshot.side === 'personal') return !!snapshot.personalUnlocked;
  if (snapshot.side === 'corporate') return !!snapshot.corporateUnlocked;
  return false;
}
